import { client } from './client'
import type { ClaudeApiTokenStatus } from '@/types'

export const userSettingsApi = {
  getClaudeToken: () =>
    client.get<ClaudeApiTokenStatus>('/users/me/claude-token').then(r => r.data),

  saveClaudeToken: (token: string) =>
    client.put('/users/me/claude-token', { token }),

  deleteClaudeToken: () =>
    client.delete('/users/me/claude-token'),
}
